import React, { FocusEvent } from "react";
import { Field } from "redux-form";
import { DateInputField, TextField } from "capitalrx-components";
import { formValidation } from "capitalrx-utilities";
import MainFormSection from "@/App/components/MainFormSection";
import { GeneralTypes } from "@/types";

interface Props {
  handleFieldOnBlur: GeneralTypes.EventWithDataHandler<FocusEvent<object>>;
}

const GeneralClaimInformation: React.FC<Props> = (props: Props) => {
  const { required } = formValidation;
  const { handleFieldOnBlur } = props;

  return (
    <MainFormSection showRequire removeSectionTitle>
      <div className="row">
        <div className="col">
          <Field
            component={DateInputField}
            id="date-of-service"
            data-testid="test__date_of_service"
            label="Date of Service"
            name="date_of_service"
            validate={[required]}
            showRequiredStar
            onBlur={handleFieldOnBlur}
          />
        </div>
        <div className="col">
          <Field
            component={TextField}
            id="prescription-service-reference-number"
            data-testid="test__prescription_service_reference_number"
            label="Prescription Service Reference Number"
            name="prescription_service_reference_number"
            onBlur={handleFieldOnBlur}
          />
        </div>
      </div>
    </MainFormSection>
  );
};

export default GeneralClaimInformation;
